/* KL narrowing row — nav build D (2026-08-26).
   Small helpers around the theme's own facets.js:
   - a members-only pill presses every hidden checkbox of its kind at once
     (the lifecycle filter is "any" logic, so two values = either);
   - the phone [more] button opens the existing filter drawer (now a sheet);
   - the sheet's green button shows the live count.
   Pressing a tag pill needs no script: the pill is the checkbox's label and
   facets.js listens for the form's input event. */
(function () {
  function wire(root) {
    root = root || document;
    root.querySelectorAll('[data-kl-multi]').forEach(function (btn) {
      if (btn.klWired) return;
      btn.klWired = true;
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        if (!form) return;
        var on = !btn.classList.contains('is-on');
        var kind = btn.getAttribute('data-kl-multi');
        form.querySelectorAll('input[data-kl-life="' + kind + '"]').forEach(function (i) { i.checked = on; });
        btn.classList.toggle('is-on', on);
        form.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    root.querySelectorAll('[data-kl-more]').forEach(function (btn) {
      if (btn.klWired) return;
      btn.klWired = true;
      btn.addEventListener('click', function () {
        var toggle = document.getElementById('Facets-Toggle');
        if (toggle) { toggle.click(); return; }
        var drawer = document.getElementById('Facet-Drawer');
        if (drawer) { drawer.classList.add('active'); document.body.classList.add('open-cc'); }
      });
    });
    var count = document.querySelector('.mobile-filter-count .facets__label');
    var apply = document.querySelector('.facet-drawer .mobile-filters-apply span');
    if (count && apply && !apply.klBase) {
      apply.klBase = apply.textContent.trim();
    }
    if (count && apply) {
      var n = (count.textContent.match(/\d+/) || [''])[0];
      apply.textContent = apply.klBase + (n ? ' · ' + n : '');
    }
  }
  document.addEventListener('DOMContentLoaded', function () { wire(); });
  document.addEventListener('kl:narrow-rendered', function () { wire(); });
  window.KlNarrow = { wire: wire };
})();
